// prettier-ignore
export default {
  generic: {
    network_error: 'Unable to connect.<br>Please check your Internet connection.',
    network_restored: 'Internet connection has been restored',
    bluetooth_error: 'Bluetooth connection is lost.<br>Please keep your device close and make sure the signal is strong enough during scan process.',
    permisson_device_orientation_not_allowed: 'To use the directional sensor feature, we suggest you restart your browser to reauthorize permission.<br>Or make sure your phone is vertically aligned with the ground before clicking Next.',
    permisson_device_orientation_not_support: 'Sorry, your browser does not support the directional sensor feature. We recommend trying another browser or device.<br>Or make sure your phone is vertically aligned with the ground before clicking Next.',
  },
  terms: {
    terms: 'Cloudzet™ Body Scanning Service (“Service”) is provided by TG3D Studio Inc. Limited and its Affiliates (“TG3D,” “We,” or “us”) under this Terms of Use (the “Terms”). <br><br>When you register the Service, you agree that you have read, understood, and consented to all the content stated in the Terms. If you are a minor, you should make sure your parents (or guardians) read, understand and agree you to comply with the Terms in full before you start using this Service. We reserve the right to modify or amend the Terms. Please visit the Terms from time to time. Your continued use of the Service after any such modification or amendment constitutes your or your parent’s (or guardian’s) acceptance of the new Terms. <br><br>Service <br><br>The Body Measurements and 3D body shape model of the User (collectively,  3D body measurements file) can be scanned and  generated by Cloudzet™ App and the Scanatic 360 Body Scanner.  When User uses the Service in the Third-party Store,  User’s 3D body measurements file is accessible by the Third-party Store for providing the custom-made clothing service and (or) recommendation service of branded clothes  to the User. Also, we will recommend personalized branded clothes to the User. The custom-made clothing service and any branded clothes are provided by the Third-party Store and clothing company, the User should review the pattern, fabric, size, cutting and the delivery of the ordered clothes carefully. <br><br>2. Definition <br><br>Software means the Cloudzet™ App developed by us and/or our affiliates, including, but not limited to, all updated versions, any supplemental and/or external apps and/or software subsequently provided by us. <br><br>User means a user who has completed the membership registration process. (“User”or “you”) <br><br>3D body measurements file means the electronic record containing the information of 3D body shape model and the Body Measurements. <br><br>3D body shape model  means the raw data of body shape shown in 3D format generated in the Service. <br><br>Body Measurements means the User’s body measurements, including but not limited to, Neck circumference, bust, waist and hips, generated in the Service <br><br>Third-party store means the third party company (including its websites and Apps) proving the service of custom-made clothing and the sales of the clothing in the Service. <br><br>3. Registration <br><br>User shall provide mobile number or email and any required information (e.g. name and gender) to complete the registration process. <br><br>User may log in the Service by connecting to your personal account of certain third party social network sites, including but not limited to, Facebook or Weixin. <br><br>4. User’s duty and Obligation <br><br>You agree to provide accurate, complete and true personal information for registration, and you may update such information online at any time. If you provide incorrect or misleading personal information that cause damages to damages to the rights or interests of other users or third parties, we may terminate your user account and use of Services, and you shall be solely responsible for the relevant legal liabilities and/or damages. <br><br>User shall further fulfill the following obligation to secure user account.  <br><br>User account shall be used by User only. You shall only use our Services and Software in accordance with the Terms and shall not allow any third party to access the Services and Software by logging in your user account. <br><br>You are obliged to properly safeguard your user account details, passwords and other relevant information. You shall be fully liable for any and all acts and/or activities, including all related fees, carried out under your user account. <br><br>If you discover any unauthorized use or unusual access to your user account, you should report to us immediately and protect your personal interests through appropriate legal means. If necessary, we will ask you to provide the relevant personal information and have the right to take charge of the account in dispute. <br><br>If unlawful use of user account and passwords is caused by your negligence or third parties’ use of the accounts with your consent, and causes damages to the interests of us or other users, you shall be solely responsible for the relevant legal liabilities and/or damages. <br><br>5. Collection of your information <br><br>Your use of the Service constitutes your consent to the collection, processing and use of your personal information, 3D body model shape and Body Measurements through the Service by TG3D for provide you the Service. <br><br>Restriction <br><br>Subject to your continuous compliance of this Terms and the additional terms and conditions imposed by the relevant Software and Services, you are authorized to use our Services and Software. If we are aware of any breach, we may suspend or terminate your right to use the Software and Services. <br><br>You are authorized to use Software and Service, but you are not allowed to modify, sub-license, lease, sell or assign any of the rights granted under the Terms. You also agree to comply with all relevant laws and regulations and use the Software and Services for lawful purposes only. <br><br>You are only authorized to use the Software. The intellectual property rights of all Software and relevant program codes are owned by us. You are prohibited from modifying, reverse engineering, reverse coding, decompiling (into a human readable format) or dissembling the Software, impeding or interfering with other user’s use of the Software and Services, or disseminating through the Software and Services virus or other malwares which are harmful to the others’ computer operation, software or contents which are in breach of the Terms and any content which may infringe the others’ intellectual property rights or other rights. <br><br>We will take all necessary steps to prevent you from using the Software and/or Services in a manner which is in breach of the Terms or the relevant laws and regulations. <br><br>7. Privacy Policy <br><br>Please refer to the Privacy Policy. <br><br>8. Intellectual Property <br><br>You are only authorized to use the Services and Software, and do not acquire from us the copyright, trademark, patent and/or any other proprietary right in the Services and Software, and any program codes provided by us. For the avoidance of doubt, all rights are reserved by us unless expressly granted to you under the Terms. <br><br>You acknowledge that our Services, Software and technology are protected by the relevant laws of their respective licensed territories and agree not to remove or modify any digital right management information, anti-piracy measures or symbols of other rights (including but not limited to patent right and trade mark right) or software, which are contained in the Services and Software. <br><br>9. Limited liability <br><br>Any information, content, software or services provided by us through Software and/or Services will be provided AS IS at the time of provision. We do not guarantee or warrant the format and content of our Services in the event of Internet connection failure, delay or other relevant communication defect. <br><br>Unless otherwise expressly stated in the law, in no event, shall we and/or our authorized agents be liable for any loss or damages, including losses caused by the use of Software and/or Services, the failure to use Software and/or Services, and/or other direct, indirect, accidental, special or consequential losses, including but not limited to loss of business profits, business loss, business interruption, business information loss and any other monetary loss. <br><br>We will not warrant and be liable for any damages or defects arising out of any and all disputes between you and the Third-party Store or any and all intentional or negligent act of other users. <br><br>Any dispute arising out of or in connection with the transaction between User and the Third-party Store or any clothing company shall be solved by the User and Third-party Store or clothing company. TG3D is not liable for any damages or defects arising out of or in connection with such disputes. <br><br>10. Amendment <br><br>We reserve the right to amend the Terms from time to time. You will be deemed to have accepted the amendments when you continue to use our Software and Services after we announce the amended Terms on our website or APP. <br><br>11. Laws and Jurisdiction <br><br>The Terms shall be construed, supplemented and applied in accordance with the laws of the Republic of China. For any matter which is not covered herein, please contact our customer service. Both parties agree that all disputes arising out of the Terms shall be subject to the jurisdiction of the Taiwan Taipei District Court if they cannot be resolved through negotiation and the parties have to resort to litigation.',
    privacy: "TG3D Studio Inc. Limited and its affiliates (“We”) take your personal privacy seriously and duly comply with the relevant privacy and personal information protection laws and regulations. Our Privacy Policy (the “Policy”), which explains what personal information we collect and how to use such data, as well as other important matters related to your privacy, is set out as the following. <br><br>When you register as a User of Cloudzet™ App (the “Service”), you will be required to enter certain information, including, but not limited to, an account ID (mobile number or email address), name, gender and date of birth. <br><br>If you connect your account via Facebook, WeChat or other services (“Third Party Service”), you agree us to collect your personal verification information and other data that may be accessible from your Third Party Service account, including your name, profile photos, country, email address, date of birth, gender, names of friends, and other personal pictures and social network. We may verify whether your data matches those collected from such Third Party Service and will store and use such data pursuant to the Policy. <br><br>When you use the Service, we may collect the following information：  <br><br>your body measurements, 3D body shape model, height, weight location information and address; <br><br>information about your use of the Service, include camera, photos and the information stored in the SD card; and <br><br>technical information, such as URL, IP address,web browser type , operation system of your device, language, and the time of visit. We employ Google Analytics to collect the aforementioned information. You could find more information about the privacy policy of Google Analytics and how to disable Google Analytics by visiting Google’s Data privacy and security. You could disable Google Analytics by downloading and installing Google Analytics Opt-out Browser Add-on. <br><br>To properly and promptly provide you with the Service, you will be required to provide the user account and the contact information when you use the Service, including but not limited to, procurement, changing the information of user account, feedback or participating in any promotional activities. <br><br>The information we collected will be used as the following: <br><br>The basic personal information you provide (such as your name) will be used for the purpose of User identification for TG3D and the Third-party store; the contact information you provide may be used for contacting you, notifying you promotional events, payment reminder, award notice, payment receipt notice, sending invoices, branded clothes recommendation and/or other update notices related to the Service. If you do not want to receive any promotional email or text message, please contact support@tg3ds.com. <br><br>Your 3D body shape model and Body Measurements will be used for providing you ,  and the service of made-to-measure,, bespoke and the recommendation of brand clothes by the Third-party Store and the recommendation service of personalized branded clothes from us. <br><br>Information about your use and technical data and 3D body measurements file generated etc. from your use of this Service may be used for improving the Service, and/or developing new services. <br><br>We will provide you for ours or any third party’s promotional information and advertisement from time to time by push notification. If you no longer wish to receive these types of communications, or if you've initially agreed for the application to access your camera, photo and SD card and you would like to stop the app from accessing them, you may turn them off at the device level. <br><br>You understand and agree that we may share with third parties the data which  is not able to reflect or specify any identifiable individual.  <br><br>The data collected herein may be processed and/or used by our affiliates or partners or outside Taiwan. We will not use them for any other purposes unless the local laws provide otherwise, and will also not disclose them to any third party without your prior consent, unless the laws require so due to material national interests or for the purpose of facilitating law enforcement agencies’ investigations. <br><br>You may search, copy or change your own personal Information. If you are not our User or we have not yet verified your membership, you are not allowed to search, copy, request for review or change the user’s personal information and account services of our accounts. For requests made in circumstances other than above, you would be required to provide your relevant personal information and written documentation as may be necessary to enable us to process your request. <br><br>You may request the use of your personal information be suspended or your own personal information be deleted.  However, once the use is suspended or personal information is deleted, you will no longer be able to use the Service. You may exercise your right to portability to obtain a copy of  your personal data provided to us. You may object to process the processing of your personal data and withdraw your consent to processing for marketing and profiling. you can always exercise your rights described above by sending a written request to us at the following address: support@tg3ds.com <br><br>You grant us an irrevocable right to use the data which is not able to reflect or specify any identifiable individual for the improvement of the Service and relevant technology and the development of the new service. <br><br>We are entitled to refuse your request to change, delete or modify your personal information if such request may be harmful to the material national interests, result in impediment to the execution of statutory duties by government agencies, or cause any prejudice to the material interests of the collecting agency or third party. <br><br>We will provide all necessary technologies and measures to protect your personal information in order to safeguard your privacy. <br><br>To avoid information leakage, you should keep your own personal information, user account and password, etc. in safe custody. To avoid misuse of your personal information, you should log out or close the software or internet browser after using the Services, whether you are using your own personal computer or not. <br><br>You should keep your payment information (including credit card details) in safe custody to avoid being used by others for illegal purpose. <br><br>The Service may include hyperlinks to third parties’ websites or web pages. We are not held jointly liable if you agree to allow those websites to collect, process, and/or use your personal information. <br><br>You agree to use true and accurate information for purchases on the Service. You should notify us immediately if you find your personal information has been misused by others or if you find something abnormal. <br><br>You agree to provide and use lawful information when using the Services and all such information does not infringe any third party’s rights, violate any third party’s agreement or otherwise involve any illegal acts. If use of the Services causes any third party’s loss, we are not liable for such loss unless it is caused by us intentionally or due to our gross negligence. <br><br>We may update this Policy from time to time and comply with the relevant local privacy laws and regulations. When we make significant changes, we will make an announcement on our official website(http://www.tg3ds.com) or APP. <br><br>This Policy constitutes part of the Terms of Service. If you do not agree any part of this Policy or any amended content, please stop using the Service immediately. <br><br>If you have any question regarding the Policy, please contact us at support@tg3ds.com",
  },
  login: {
    cloudzet_welcome: 'Hi, Welcome to Cloudzet',
    mtm_username: 'Scanatic™ Account',
    password: 'Password',
    login: 'Log In',
    logging_in: 'Logging in...',
    no_login_methods: 'No login methods set for this Scanatic™ account',
    agreements_button: 'Agree & continue',
    complete_email_reset_pwd_title: `We've got your back!`,
    sent_email: `We've sent an email to`,
    email_reset_pwd: 'Please follow the instruction to reset the password',
    get_the_code: 'Don’t you get the code?',
    resend: 'Resend',
    complete_phone_reset_pwd_title: 'Congratulations!',
    login_new_password: 'The new password has been set,<br />please log in with the new password',
    login_my_account: 'Login to my account',
    sent_a_code: 'We just sent a code to',
    received_code: 'Let me know if you received it',
    verification_code_error: 'Verification code error',
    continue: 'Continue',
    forget_your_password: 'Forget your password?',
    forget_password_text: `Don't worry!`,
    send: 'Send',
    submit: 'Submit',
    no_such_user: 'Account not found',
    email_prompt_text: `We'll send you an email to reset your password`,
    phone_prompt_text: `We will send you a 4-digit verification code`,
    login_title: 'Welcome back!',
    login_email_title: 'Log in with Email',
    login_phone_title: 'Log in with Phone',
    forget_password: 'Forget Password?',
    terms_of_service: 'Our terms of service',
    choose_a_country_code: 'Choose a country code',
    choose_a_country_code_hint: 'Login/registration is available only in the following countries and regions.',
    country_code_not_found: `Couldn't find your country code?`,
    sign_up_email: 'Sign up with email',
    email_sign_up_error_msg: 'Please enter the correct email',
    four_characters: 'Your password must be at least 4 characters',
    try_to_login: 'This account already exists. Try logging in',
    try_use_email: 'Try using your email',
    sign_up: 'Sign up',
    sent_verification_code: 'We will send you a 4-digit verification code.',
    sign_up_phone: 'Sign up with Phone',
    sign_up_store: 'Sign up with store',
    set_up_new_pwd: 'Now, set up a new password',
    set_up_new_password: 'Now, you may set up<br> your new password',
    set_new_pwd: 'Set new password',
    enter_country_code: 'Enter country code',
    enter_email_address: 'Enter your Email address',
    enter_phone_number: 'Enter your Phone Number',
    customer_account_name: 'Customer account name',
    enter_password: 'Enter password',
    re_enter_password: 'Re-enter password',
    login_social_accounts: 'Sign up with social account',
    social_login_failed: 'Failed to login with social account',
    login_first: 'Please login first',
    create_with_store: 'Create with store',
    verify: 'Verify',
    welcome_to_store: 'Welcome to {storeName}!',
    login_to_continue: 'Login/ Sign up to continue',
    wrong_password: 'Incorrect password. Please enter again.',
  },
  stamp: {
    tap_to_start: 'スキャン開始手順を読み<br>準備ができたら、タップしてください',
    tap_camera_on: '指でタップしてカメラを起動',
    welcome_title: 'Welcome to<br>STAMP SCAN BOX',
    note_front_camera: 'あなたのスマートフォンを使ってLINE上からSCAN CODEを起動し、前面のカメラにかざしてログインしましょう',
    scan_code_title: '',
    scan_code_hint: 'SCAN CODEを枠内にかざしてください',
    things_to_note_title: 'Before The 3D Body Scan',
    clothes_info: '肌に密着した下着のみになってください<br>衣類はボックスに入れてください',
    clothes_alt_info: '男性のトランクス、女性のブラトップなど、ゆとりのありすぎる衣類では、正常にスキャンできない場合があります',
    accessories_info: 'メガネ以外のアクセサリー類は外してください<br>髪の長い方は首にかからないように結んでください',
    accessories_alt_info: 'ヘアゴムはボックス内に、用意しています',
    touch_for_tutorial: 'スキャンの準備ができたら指でタップ',
    tutorial: {
      title: 'The Contactless Control Tutorial',
      contactless: '3Dスキャンの操作ガイドを始めます',
      clench_fingers: '両手は軽く握り、握り拳を作ります',
      raise_arm: 'マークの位置まで両腕をあげます',
      raise_arm_2: 'マークの位置でセンサーが反応し、スキャンが始まります',
      feet_pos: '足型に合わせて気を付けの姿勢で立ちます',
    },
    choose_to_start: {
      title: '3D Scan Tutorial',
      start: 'マークの位置まで両腕をあげてください',
      done: 'この体制でスキャンが始まります',
    },
    end_goodjob: 'おつかれさまでした',
    end_line: 'LINEスキャンメニューからカメラを起動し、<br>QRコードを読み取ってチェックアウトしましょう',
    choose_step_info: 'マークの位置まで右腕をあげてください',
    clench: '両手は軽く握り、握り拳を作ってください',
    feet_position: '足型に合わせて気を付けの姿勢で立ってください',
    raise_arm: 'マークの位置まで両腕をあげてください',
    hold_left: '左腕を、マークの位置までゆっくりあげてください',
    hold_right: '右腕を、マークの位置までゆっくりあげてください',
    scan_step_name_begin: 'Begin the 3D Body Scan',
    scan_step_name: '3D Body Scan',
    scan_step_name_2: '2nd Time 3D Body Scan',
    scan_body_start: 'マークの位置まで両腕をあげてください',
    scan_in_progress: 'スキャンが始まります<br>そのまま動かないでください',
    scan_complete_1: '1回目のスキャンに成功しました。<br>腕を降ろして、リラックスして下さい',
    scan_complete_2: '2回目のスキャンに成功しました。<br>腕を降ろして、リラックスして下さい',
    analyzing: '3Dデータを生成しています',
    leave: 'ログアウト',
    end_next: 'スキャンを終了する',
    end_next_info: 'Next Information',
    end_instruction: '洋服を着て下さい。<br> 続けて、外のタブレットへと移動し、<br> 新たな体験をお楽しみください。',
    scan_again: 'もう一度スキャン',
    scan_unsuccessful: 'スキャンに失敗しました',
    scan_successful: 'スキャンデータの生成に成功しました',
    neck: '首回り',
    chest: 'チェスト',
    chest_female: 'バスト',
    torso: '胴回り',
    mid_waist: 'ウエスト',
    hip: 'ヒップ',
    shoulder: '肩幅',
    biceps: '上腕回り',
    arm: '腕丈',
    thigh: '太もも',
    inner_leg: '股下-地面',
    avoid_errors: 'スキャン時の注意事項を確認してもう一度スキャンしてください',
    error_accessories: 'メガネ以外のアクセサリー類を外してください',
    error_cover_neck: '髪の長い方は首が隠れないよう結んでください',
    error_floor_marks: '足型に合わせて立ってください',
    error_postural: 'スキャン時は姿勢を正してください',
    welcome_steps: 'スキャン開始手順',
    welcome_step_1: '靴と鞄はボックスに入れてください',
    welcome_step_2: 'LINE下部メニューのスキャンコードをタップしQRコードを発行します',
  },
  incein: {
    welcome_step_1: '靴と鞄はミラー近くのボックスに入れてください。',
    welcome_step_2: 'LINE下部メニューのスキャンコードをタップしQRコードを発行します。',
    things_to_note_title: 'Before scanning...',
    clothes_alt_info: 'トランクス、ブラトップなど、ゆとりのある衣装では正常にスキャンできない場合があります。',
    scan_step_name_begin: 'Begin to scan',
    scan_in_progress: 'スキャンを開始します<br>そのまま動かないでください',
    scan_complete_1: '1回目のスキャンに成功しました<br>腕をおろして、リラックスしてください',
    scan_step_name_2: '2nd time body scanning',
    scan_complete_2: '2回目のスキャンに成功しました<br>腕をおろして、リラックスしてください',
  },
  hm: {
    end_title: 'Thank you!',
    end_text: 'You can now return to the Body Scan Jeans Design Station to customize your jeans.<br>Remember to carry your personal belongings with you.',
  },
  welcome: {
    enable_bt: 'Please turn on bluetooth before proceeding',
    welcome_title: 'Welcome To The<br> 3D Scanning Room',
    powered_by: 'Powered by TG3D Studio Inc.',
    tap_to_start: 'Tap the bubble to start',
    tap_camera_on: 'Turn on camera to scan QR code',
    ready_to_scan_qr: 'Ready To Scan QR Code',
    note_front_camera: 'Please note that the front camera will be used when scanning QR Code',
    scan_code_title: 'Scan QR Code To Begin',
    scan_code_hint: 'Please put the QR code in the box',
    scan_code_processing: 'Processing...',
    scan_code_logging_in: 'Logging into your account...',
    scan_code_connect_to_scanner: 'Connecting to the scanner...',
    scan_code_no_account: 'Account does not exist. Please try again.',
    scan_code_done: 'Ready to go!',
    no_scanner_id: 'No scanner id setup for this Scanatic™ account',
    no_scanner_found: 'Specified scanner not found',
    scanner_in_use: 'The scanner is being used',
    unexpected_error: 'Something went wrong :( <br>Please try again.',
    need_camera_permission: 'You must grant camera permission to use this feature',
    share_qr_code: 'Show my QR code',
    my_qr_code: 'My QR code',
    scan_qr_code_reminder: 'You will be logged in to other devices when you scan the QR Code.',
  },
  choose: {
    step_name: 'Prepare for 3D Body Scan',
    step_info: 'When you are ready,<br>move your fists into the bubbles',
    tutorial: 'Tutorial',
    start_scan: '3D scan',
    clench_fingers: 'Lightly clench your fingers',
    raise_arm: 'Move your arm until you touch the bubble',
    hold_til_fill: 'Now hold until the bubble is filled',
  },
  thingstonote: {
    title: 'Before The 3D Body Scan',
    wear_tight: 'Wear skin-tight and form-fitting clothings',
    tie_hair: 'Tie up your hair to show the back of your neck',
    remove_acc: 'Remove all of your accessories',
  },
  scanscreen: {
    skip: 'Skip',
  },
  tutorial: {
    title: 'The Contactless Control Tutorial',
    contactless: 'The contactless experience ensures your health is protected',
    clench_fingers: 'Lightly clench your fingers',
    raise_arm: 'To control the bubbles, please move your arms until you touch the bubbles and hold for 2 seconds',
    hold: 'Now hold until the bubble is filled',
    proceed: 'To proceed to the next step, move your right arm until it touches the bubble.',
    return: 'To return to the previous step, move your left arm until it touches the bubble.',
    feet_pos: 'Position your feet on the floor mat',
  },
  scan: {
    feet_pos: 'Position your feet on the floor mat',
    step_name: '3D Body Scan',
    phase_one_done: 'Phase 1 completed',
    begin_2nd: 'Begin the 2nd-Pose Body Scan',
    clench: 'Lightly clench your fingers',
    raise_both_arm: 'Move your arms slowly and hold your fists in the bubbles',
    raise_fists: 'Move your fists outward to the bubble area',
    lower_fists: 'Move your fists inward to the bubble area',
    hold_still: 'Hold your arms still',
    scan_keep_still: 'Keep your body still',
    scan_in_progress: 'Scanning in progress',
    scan_complete: 'Scan completed. <br>You may relax your body.',
    two_step_scan: 'The scan will be conducted in 2 phases',
    raise_elbow: 'Raise elbows outward to keep arms from touching the body during the scan',
    scanner_occupied: 'Scan room is occupied.  Please contact the staff to reset the scanner and re-try.',
    scanner_error_need_reset: 'Scanner error.  Please contact the staff to reset the scanner and re-try.',
    scanner_error_generic: 'Scanner error.  Please contact the staff.',
    scanner_not_activated: 'Scanner is not activated.  Please contact the staff.',
    scanner_check_network: 'Please contact the staff to check if the scanner is connected to the internet or reset the scanner and re-try.',
  },
  handles: {
    hold: 'Hold the Handles.<br>Arms Relaxed and Straightened',
    hold_ready: 'Hold the Handles.<br>You Are Now Ready',
    letgo_and_keep_feet: 'Let go the handles & keep your feet on the floor marks',
    clench_ipose: 'Fists lightly clenched, hands about 5 cm (2 inches) apart from body',
    clench_ready: 'Fists lightly clenched, You Are Now Ready',
  },
  end: {
    thank: 'Thank you !',
    belonging: 'Please remember to carry your personal belongings with you.',
  },
  analyzing: {
    check_err: 'Creating 3D avatar...',
  },
  result: {
    scan_successful: 'Great job!<br>Your 3D scan was successful',
    scan_unsuccessful: 'Oops!<br>We are unable to process your data',
    avoid_errors: 'Common Causes Of Scan Errors',
    error_accessories: 'Wearing accessories',
    error_cover_neck: 'Hair covering your neck',
    error_floor_marks: 'Feet in wrong position',
    error_postural: 'Incorrect posture',
    leave: 'Leave',
    raise: 'Move your fists into the bubbles to scan again',
    scan_again: 'Scan Again',
    analyzing: 'Processing your scan data...',
    click_scan_again: 'Click the button below to scan again',
    oops: 'Oops!',
    unexpected_error: 'Something seems wrong...',
    close: 'Close',
  },
  measurement: {
    neck: 'Neck',
    chest: 'Chest',
    torso: 'Torso',
    mid_waist: 'Mid Waist',
    hip: 'Hip',
    shoulder: 'Shoulder',
    biceps: 'Biceps',
    arm: 'Arm',
    thigh: 'Thigh',
    inner_leg: 'Inner Leg',
    chest_female: 'Bust Girth',
    under_bust: 'Under Bust',
    breast_triangle: 'Breast Triangle',
    spine_angle: 'Spine Angle',
    breast_volume: 'Breast Volume',
    bra_strap: 'Bra Strap',
    pelvic_tilts: 'Pelvic Tilts',
    rounded_shoulder: 'Round Shoulder',
    neck_to_hip_height: 'Neck to Hip Height',
    neck_to_back_depth: 'Neck to Back Depth',
  },
  homePage: {
    firstScanTitle: 'Start your<br/>journey to the future',
    tap_to_scan: 'Tap to 3D Scan',
    measurement: 'Measurement',
    body_3d_avatar: '3D Body',
    see_more: 'See more',
    menu: 'Menu',
    store_settings: 'Store settings',
    avatar_shader_3d: '3D Avatar Shader',
    avatar_shader: 'Avatar shader',
    create_3d_shader: 'Create 3D Shader',
    language: 'Language',
    get_help: 'Get Help',
    feedback: 'Feedback',
    send_feedback: 'Send feedback',
    send_btn: 'Send',
    send_feedback_placeholder: 'Your feedback will help us improve our product and service',
    send_feedback_title: 'Thanks for your feedback',
    send_feedback_content: "We will be taking notes of your feedback and hope to provide a better experience in the future. Please don't hesitate to reach out if you have more to say!",
    report_crash: 'Report a crash',
    report_crash_title: 'Thanks for letting us know',
    report_crash_content: "We are sorry for your experience. <br>Our team will be inspecting this problem as soon as possible. At the same time, please don't hesitate to reach out if you encounter other issues.",
    rate_app: 'I love Cloudzet App',
    rate_app_title: 'Rate Cloudzet App',
    rate_app_content: 'If you love our app, please take a moment to rate or review it in the App Store. Thank you!',
    login_s4f: 'Login with <br/> Scanatic™ account',
    login: 'Login',
    password: 'Password',
    account_settings: 'Account settings',
    enter_Scanatic_account: 'Enter Scanatic™ account',
    logout: 'Log out',
    delete_account: 'Delete account',
    confirm_delete: 'Are you sure?',
    contactless_scan: 'Contactless Scan',
    delete: 'Delete',
    cancel_delete: 'Cancel',
    ok: 'Okay',
    scan_to_login: 'Scan QR code',
    history: 'History',
    view_avatar: 'View 3D avatar',
    select_date: 'Select the date',
    select: 'Select',
    analysis: 'Analysis',
    comparison: 'Comparison',
    leftCompareView: 'Left Model',
    rightCompareView: 'Right Model',
  },
  settingUserData: {
    your_birth: 'Tell me your year of birth?',
    your_gender: 'Tell me your gender',
    female: 'Female',
    male: 'Male',
    tall: 'How tall are you?',
    cm: 'cm',
    ft: 'ft',
    inch: 'inches',
    your_height: 'Height',
    your_weight: 'How much do you weight?',
    weight: 'Weight',
    lbs: 'lbs',
    kg: 'kg',
    nickname: 'Your name',
    metric: 'cm/kg',
    imperial: 'ft/lbs',
  },
  profile: {
    profile: 'Profile',
    edit_profile: 'Edit Profile',
    name: 'Name',
    birthday: 'Birthday',
    birthyear: 'Birth Year',
    phone: 'Phone Number',
    email: 'Email',
    address: 'Address',
    save: 'Okay',
    file_size_exceed: 'File size cannot exceed 1MB',
  },
  discover: {
    head_title: 'Discover',
    check_my_size: 'Check My Size',
    rmd_size: 'Recommended Size',
    no_rmd_data: 'No recommended size for this item',
    no_rmd_items: 'Oops! No recommended item found',
    buy_item: 'Buy',
  },
  discovery: {
    turn_on_bt: 'Turn on Bluetooth',
    turn_on_bt_hint: 'Authorize and Enable Bluetooth',
    turn_on_bt_hint_ios: 'Please make sure the following settings are completed:<br>1. Grant permission<br>　● Go to Settings > Privacy & Security > Bluetooth and enable acces for Cloudzet.<br>2. Turn on Bluetooth<br>　● Go to Settings > Bluetooth and switch it On.',
    turn_on_bt_hint_android: 'Please make sure the following settings are completed:<br>1. Turn on Bluetooth<br>　● Swipe down from the top of the screen, then tap Bluetooth.',
    searching: 'Searching for nearby devices...',
    select_scanner: 'Select a nearby scanning device to start',
    scanner__foot: 'Foot Scanner',
    scanner__body: 'Body Scanner',
    start_scan: 'Start 3D Scan',
    no_scanners: "Can't find any nearby scanners",
    try_again: 'Try again',
    scanner_is_busy_title: 'Scanner is Occupied',
    scanner_is_busy_desc: 'Please check if there is anyone inside using the scanner.',
    scanner_is_busy_force_release: 'Scan now',
    scanner_is_busy_wait: 'Wait for scanning',
  },
  footscan: {
    take_off: 'Before the 3D scan<br>please take off your shoes',
    barefoot: 'Wear close-fitting socks<br>or go barefoot',
    show_ankles: 'Roll up your trouser legs<br>to reveal your ankles',
    sit: 'Please sit down with<br>your knees bent at 90° angle',
    stand_up: 'Please stand up',
    position_feet: 'Position your feet on the<br>area marked on the floor',
    start_scan: 'Ready to scan',
    ready_to_scan: 'Ready to go!',
    stand_up_for_2nd_scan: 'Please stand up and face straight to prepare for the scan',
    stand_still: 'Please keep your body still<br>and face forward',
    scan_complete: 'Scan completed<br>You may relax',
    creating_3d_foot: 'Creating 3D foot model...',
    scan_successful: 'Great job!<br>Your 3D scan was successful',
    click_to_rescan: 'Click the button below<br>to scan again',
    feet_3d: '3D Feet',
    analysis: 'Foot Analysis',
    initial_l: 'L',
    initial_r: 'R',
    tab__fit: 'Shoes Fit',
    tab__width: 'Width',
    tab__arches: 'Arches',
    tab__measure: 'Measure',
    tab__type: 'Type',
    shoes_guide: 'Shoes size guide',
    shoes_last: 'Your shoe last',
    measurement__ball: 'Ball Circumference',
    measurement__foot_length: 'Length',
    measurement__foot_width: 'Width',
    measurement__instep: 'Instep Circumference',
    measurement__span: 'Span Circumference',
    measurement__arch: 'Arches',
    measurement__finger_shape: 'Foot Type',
    arch_type__title: 'Your Foot Arches',
    arch_type__high: 'High Arch',
    arch_type__summary_high: 'The arch of a cavus foot will appear high even when standing. In addition, one or more of the following symptoms may be present.',
    arch_type__desc_high: ' • Hammertoes (bent toes) or claw toes.<br>' +
      ' • Calluses on the ball, side or heel of the foot.<br>' +
      ' • Pain when standing or walking.<br>' +
      ' • An unstable foot due to the heel tilting inward, which can lead to ankle sprains.',
    arch_type__normal: 'Normal Arch',
    arch_type__summary_normal: 'If the middle part of your arch is about half filled, this means you have a normal arch.',
    arch_type__desc_normal: ' • Hammertoes (bent toes) or claw toes.<br>' +
      ' • Calluses on the ball, side or heel of the foot.<br>' +
      ' • Pain when standing or walking.<br>' +
      ' • An unstable foot due to the heel tilting inward, which can lead to ankle sprains.',
    arch_type__low: 'Low Arch',
    arch_type__summary_low: 'Pronation is a term used to describe the inward leaning motion of the foot and ankle bones towards the arch.',
    arch_type__desc_low: ' • Hammertoes (bent toes) or claw toes.<br>' +
      ' • Calluses on the ball, side or heel of the foot.<br>' +
      ' • Pain when standing or walking.<br>' +
      ' • An unstable foot due to the heel tilting inward, which can lead to ankle sprains.',
    foot_type__title: 'Your Foot Type',
    foot_type__egyptian: 'Egyptian Toe',
    foot_type__summary_egyptian: 'The toes decrease in length from the big toe to the little toe.',
    foot_type__desc_egyptian: 'The feet of most Asian men have long big toes and sloping toe bones.<br>' +
      'Wearing shoes is easy to squeeze the big toe. It is best to choose shoes with a slightly inclined toe weight.<br>' +
      'Most of the amount falls on the big toe, it is easy to turn the toes, not suitable for pointed shoes.',
    foot_type__roman: 'Roman Toe',
    foot_type__summary_roman: 'The first 3 toes are of equal length, while the other two are shorter.',
    foot_type__desc_roman: 'This particular toe shape is characterised by the first three toes being of the same height, with the other two in descending order. The people who sport this toe type are known to have a balanced body shape, as well as personality.',
    foot_type__greek: 'Greek Toe',
    foot_type__summary_greek: 'Second toe protrudes more than the rest, including the big toe.',
    foot_type__desc_greek: 'The second toe toe muscles, so the second toe toe muscles collide with the toe, and friction will cause toe toe pain. It is recommended to use round toe shoes, oblique toe shoes, and shoes that do not step on toes.',
    foot_type__unknown: 'Unknown',
    foot_type__summary_unknown: 'Summary Unknown',
    foot_type__desc_unknown: 'Desc Unknown',
  },
  mobileScan: {
    mobile_scan: 'Mobile Scan',
    body_scanner: 'Body Scanner',
    data_processing: 'Scan data processing...',
    comeback_later: 'Please come back in 5-10 minutes to review your 3D avatar',
    data_process_failed: 'Unable to process scan data',
    error_not_inscreen: 'Your entire body isn\'t captured in the screen',
    error_messy_background: 'The background is too messy',
    device_unsupported: 'Oops!<br>Your device doesn\'t support mobile phone 3D scan',
    need_faceid: 'The mobile 3D body scan can only be operated on iPhone X or newer iPhones with Face ID',
    scanner_name: 'Mobile 3D Body Scan',
    confirm_info: 'Please confirm your personal information',
    begin_title: 'Get Ready to Scan',
    begin_info: 'Wear skin-tight clothings<br>and tie up your hair to <br>show the back of your neck',
    start_tutorial: 'Start tutorial',
    not_first: 'Not your first time here?',
    skip_tutorial: 'Skip tutorial',
    vertical_info: 'Place the phone<br>vertically on a<br>flat surface',
    inscreen_info: 'Make sure that<br>your entire body<br>is captured',
    backoff_info: 'Click next, go back<br>and get in scanning<br>pose in 10 sec.',
    spin_info: 'Clench your fingers,<br>open arms and rotate<br>in 360° within 10 sec.',
    check_title: 'Get Ready to Scan',
    check_info: 'Please confirm on the<br>following checklist',
    wear_tight: 'Wear skin-tight clothings and tie up your hair',
    wipe_front: 'Clean the front camera lens',
    volume_up: 'Turn the volume all the way up',
    next: 'Next',
    start_scan: 'Start Scan',
    starting_in: 'Starting in',
    preview_info: 'Please confirm on the<br>following checklist',
    preview_inscreen: 'Entire body is captured',
    preview_arms_open: 'Arms opened and fingers clenched',
    preview_spin: 'Rotate 360°',
    preview_delete: 'The video will be deleted once avatar is created',
    rescan: 'Scan again',
    uploading: 'Scan data processing...<br>Do not close the window',
    uploading_done: 'Analysis complete!<br>Please come back in 5-10 minutes to review your 3D avatar',
    finish_btn: 'Finish',
    upload_error: 'The mobile 3D body scan function isn\'t enabled<br>Please contact your selected store for more information',
    no_balance: 'The mobile 3D body scan function is suspended<br>Please contact your selected store for more information',
    scan_limit_reached: 'You have reached your scanning limits for this month<br>(each scan account is capped at 3 times per month)',
    leave: 'Leave',
    no_credits: "Oops!\nYou don't have enough credits",
    no_email: "Oops!\n You have to enter \nyour email address first",
    credits: 'Your Credits',
    purchase: 'Buy Credit',
    purchase_cart: 'My Cart',
    purchase_total: 'Total',
    purchase_item: 'Item',
    purchase_checkout: 'Checkout',
    purchase_reminder: 'We will send an invoice to your email address.',
    payment_succeed: 'Congratulations! \nYour order has been placed',
    payment_succeed_des: 'We will send an email\nto confirm your order details',
    update_email: 'Update Email'
  },
  mobileScan2: {
    inscreen_front_info: 'Make sure your entire body is visible on the screen with arms and lets slightly apart',
    inscreen_side_info: 'For the side photo, Please turn left. Keep your feet together and place both hands against the outside of your thighs',
    inscreen_info: 'Make sure your entire body is visible on the screen',
    trun_left_info: 'Turn left, place hands against the outside of thighs, keep feet together',
  },
  share: {
    voucher_expired: 'Session expired.<br>Please restart the page.',
    no_scan_data: 'No scan results found.',
  },
};
